Controller = App.loadClass 'core::Angular/Controller'

class exports.SlackFilesSidebarController extends Controller
    constructor: (@scope, @transitions) ->
        super
